<template>
  <footer v-if="!isFooterHidden">
    <div v-if="isTranslationsReady">
      <div id="footer-body-wrapper">
        <div id="footer-body">
          <div class="container">
            <div class="footer-column">
              <div id="footer-logo" :class="{ [logoClass]: true }"></div>
            </div>
            <div class="footer-column align column">
              <ul>
                <li>
                  <a data-test-id="footer-faq" :title="$t('footer_help_faq')" target="_blank" :href="getURL('faq')">{{ $t('footer_help_faq') }}</a>
                </li>
                <li>
                  <a data-test-id="footer-contact-us" :title="$t('footer_contact_us')" target="_blank" :href="getURL('contact')">{{ $t('footer_contact_us') }}</a>
                </li>
              </ul>
              <app-store-icon-list />
            </div>
          </div>
          <div class="separator"></div>
          <div class="microsite-footer">
            <div class="footer-column">
              <span class="richtext">&copy; {{ `${new Date().getFullYear()}` }} &nbsp;{{ countryConfig.legalEntityName }}</span>
            </div>
            <div class="footer-column">
              <a data-test-id="footer-provider" :href="getURL('legal', 'imprint')" :title="$t('footer_provider')" target="_blank">{{ $t('footer_provider') }}</a>
              <a data-test-id="footer-privacy" :href="getURL('legal', 'privacy')" :title="$t('footer_privacy')" target="_blank">{{ $t('footer_privacy') }}</a>
              <a data-test-id="footer-cookies" @click="showConsents" :title="$t('footer_cookies')">{{ $t('footer_cookies') }}</a>
            </div>
            <div class="footer-column" v-if="getAvailableLanguages().length">
              <div class="footer-custom-select">
                <i class="icon-ic-chevron-down"></i>
                <select data-test-id="footer-language-selector" v-model="selectedLocale" @change="changeLang(selectedLocale)">
                  <option v-for="(lang, index) in getAvailableLanguages()" :key="index" :value="`${lang}-${country}`">{{ lang }}</option>
                </select>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </footer>
</template>

<script lang="ts">
import { getCountryConfig, EntityConfig } from '@/data/country.config';
import AppStoreIconList from '../app-store-icon-list/AppStoreIconList.vue';
import { mapActions, mapGetters, mapState } from 'vuex';
import { defineComponent } from 'vue';
import { UsersState } from '@/store/user/user.model';
import { AppState } from '@/store/app/app.store';

export default defineComponent({
  name: 'AppFooter',
  components: {
    AppStoreIconList,
  },

  data() {
    return {
      selectedLocale: undefined as string | undefined,
    };
  },

  computed: {
    ...mapGetters('users', ['country', 'language']),
    ...mapGetters('app', ['isTranslationsReady']),

    ...mapState('users', {
      user: (state) => (state as UsersState).user,
    }),

    ...mapState('app', {
      isFooterHidden: (state) => (state as AppState).isFooterHidden,
      activeLanguage: (state) => (state as AppState).activeLanguage,
      logoClass: (state) => (state as AppState).logoClass,
    }),

    countryConfig(): EntityConfig {
      return getCountryConfig(this.country, this.user.legalEntityId);
    },
  },

  methods: {
    ...mapActions('app', ['loadTranslations']),

    getURL(path: string, hash?: string): string {
      const countryLanguage = `${this.country}/${this.language}`;
      return `/${countryLanguage.toLowerCase()}/${path}/${hash ? `#${hash}` : ''}`;
    },

    showConsents() {
      (window as any).UC_UI?.showSecondLayer();
    },

    async changeLang(localeString: string) {
      await this.loadTranslations({ isTemp: false, localeString });
    },

    getAvailableLanguages() {
      if (!this.country) {
        return [];
      }

      this.selectedLocale = `${this.activeLanguage}-${this.country}`;

      return this.countryConfig.languages;
    },
  },
});
</script>

<style src="./app-footer.component.scss" lang="scss"></style>
